/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BomModelGeneratorCreateDTO } from '../models/BomModelGeneratorCreateDTO';
import type { BomModelGeneratorEditDTO } from '../models/BomModelGeneratorEditDTO';
import type { BomModelGeneratorViewDTO } from '../models/BomModelGeneratorViewDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BomModelGeneratorService {

    /**
     * @param requestBody 
     * @returns BomModelGeneratorViewDTO Success
     * @throws ApiError
     */
    public static postBackendv2BommodelgeneratorGenerate(
requestBody?: BomModelGeneratorEditDTO,
): CancelablePromise<BomModelGeneratorViewDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/bommodelgenerator/generate',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param requestBody 
     * @returns BomModelGeneratorViewDTO Success
     * @throws ApiError
     */
    public static postBackendv2BommodelgeneratorCreate(
requestBody?: BomModelGeneratorCreateDTO,
): CancelablePromise<BomModelGeneratorViewDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/bommodelgenerator/create',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
